// extracted by mini-css-extract-plugin
export default {"game":"Game_game__lVNa6","glow":"Game_glow__y5tlO"};